// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ctabs[data-v-e53ab194]{overflow-x:auto;border-radius:18px !important;margin-top:1rem !important;padding:4px;background-color:#e8e8e8}.ctab-item[data-v-e53ab194]{width:100%;border-radius:18px !important;text-align:center}.ctab-item.selected[data-v-e53ab194]{background-color:#fff}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
